// 位置卡片組件
import { PlaceWithServices } from '../../../models/Place.ts';
import { Badge, Paper, Text, Tooltip } from '@mantine/core';
import {
  getServiceColor,
  getServiceLabel,
} from '../../../const/service_type_mapping.ts';
import { getPublishStatusColor } from '../../../const/place_publish_status_mapping.ts';
import React from 'react';
import { useTheme } from '../../../context/ThemeProvider.tsx';
import { ServiceType } from '../../../models/ServiceType.ts';

const SERVICE_ORDER: ServiceType[] = [
  'PARKING',
  'CHARGING',
  'FUELING',
  'MAINTENANCE',
  'INSPECTION',
];

interface LocationCardProps {
  place: PlaceWithServices;
  isSelected: boolean;
  onClick: () => void;
}

const LocationCard: React.FC<LocationCardProps> = ({
  place,
  isSelected,
  onClick,
}) => {
  const { colorScheme } = useTheme();

  return (
    <Paper
      p="16"
      withBorder
      shadow="sm"
      style={{
        cursor: 'pointer',
        transition: '0.2s',
        backgroundColor: isSelected ? '#228BE61A' : '#FFFFFF1A',
        border: isSelected
          ? '3px solid #228BE6'
          : colorScheme === 'light'
            ? '1px solid #DEE2E6'
            : '1px solid #5a5a5aff',
        width: 331,
        borderRadius: 8,
      }}
      onClick={onClick}
    >
      <div style={{ position: 'relative' }}>
        {/* 地點名稱 & 狀態 */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            justifyContent: 'space-between',
            minHeight: 25,
          }}
        >
          <Tooltip
            label={place.name}
            position={'top'}
            offset={0}
            openDelay={200}
            color={'rgba(120, 120, 120, 0.85)'}
            style={{
              fontSize: 12,
            }}
          >
            <Text
              fz={16}
              fw={700}
              pr={15}
              truncate={'end'}
              style={{ height: 25, maxWidth: 290 }}
            >
              {place.name}
            </Text>
          </Tooltip>
          <div
            style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              backgroundColor: `${getPublishStatusColor(place.publishStatus)}`,
            }}
          />
        </div>
        {/* 地址 */}
        <Tooltip
          label={place.address}
          position={'bottom'}
          offset={0}
          openDelay={200}
          color={'rgba(120, 120, 120, 0.85)'}
          style={{
            fontSize: 12,
          }}
        >
          <Text
            fz={14}
            fw={400}
            c="dimmed"
            truncate={'end'}
            style={{ height: 20, alignContent: 'center' }}
            mb={16}
          >
            {place.address}
          </Text>
        </Tooltip>
        {/* 服務 */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {[...place.services]
            .sort(
              (a, b) =>
                SERVICE_ORDER.indexOf(a.serviceType) -
                SERVICE_ORDER.indexOf(b.serviceType),
            )
            .map((service, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                }}
              >
                <Badge
                  size="xs"
                  variant="light"
                  style={{
                    width: 54,
                    height: 16,
                    backgroundColor: `${getServiceColor(service.serviceType)}`,
                    color: 'black',
                    fontSize: 10,
                    padding: '2px 5px',
                    borderRadius: 10,
                    fontWeight: 600,
                  }}
                >
                  {getServiceLabel(service.serviceType)}
                </Badge>
                <Tooltip
                  label={service.name}
                  position={'bottom'}
                  offset={0}
                  openDelay={200}
                  color={'rgba(120, 120, 120, 0.85)'}
                  style={{
                    fontSize: 12,
                  }}
                >
                  <Text
                    truncate={'end'}
                    style={{
                      fontSize: 12,
                      lineHeight: '16px',
                      fontWeight: 400,
                      maxWidth: 228,
                      maxHeight: 16,
                    }}
                  >
                    {service.name}
                  </Text>
                </Tooltip>
              </div>
            ))}
        </div>
      </div>
    </Paper>
  );
};

export default LocationCard;
